import SectionHeading from "@/components/base/SectionHeading";
import CategoryCard from "@/components/base/CategoryCard";
import { categories } from "@/mocks/categories";

function CategoryGrid() {
  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="主题分类"
          title="按主题查找你关心的线索"
          description="线索按主题归档，方便集中处理同类问题。如果你手里的材料不属于现有分类，也可以在投稿时自行说明。"
          actionText="全部分类"
          actionTo="/categories"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category) => (
            <CategoryCard key={category.slug} category={category} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default CategoryGrid;